import { useQuery } from "@tanstack/react-query";
import apiDal from "../config/apiDal";
import { Report } from "../types";

const fetchFindReports = async (): Promise<Report[]> => {
	const response = await apiDal.post("/queries/fetch", {
		query: "getFindReports",
		bind: {
			report: -1,
		},
	});

	return response.data.result;
};

export const useGetFindReports = () => {
	return useQuery<Report[]>({
		queryKey: ["getFindReports"],
		queryFn: () => fetchFindReports(),
		refetchOnWindowFocus: true,
		refetchOnMount: true,
		staleTime: 0,
		select: (data): Report[] =>
			data.map((report: any) => ({
				...report,
				lossObjectImages: safeParseImages(report.lossObjectImages),
			})),
	});
};

// Helper to safely parse images JSON
const safeParseImages = (input: string): string[] => {
	try {
		const parsed = JSON.parse(input);
		return Array.isArray(parsed) ? parsed : [];
	} catch {
		return [];
	}
};
